import React from "react";
import { Form, Input, Modal } from "antd";

export default function PurchaseAddInvoiceModal(props) {

  const { open, onClose, target} = props;
  const [form] = Form.useForm();

	return(
    <Modal
      open={open}
      onCancel={onClose}
      okText={"ตกลง"}
      cancelText={"ไม่"}
      title={"เพิ่มใบส่งสินค้า"}
      width={500}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 17}}>
        <Form.Item label={'หมายเลขตู้'}>
          <Input/>
        </Form.Item>
        <Form.Item label={'หมายเลข Seal '}>
          <Input/>
        </Form.Item>
        <Form.Item label={'ทะเบียนรถ'}>
          <Input/>
        </Form.Item>
        <Form.Item label={'น้ำหนักขาย'}>
          <Input/>
        </Form.Item>
      </Form>
    </Modal>
)
}